import React from "react";
import {
  Paper,
  Skeleton,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colorBrandObject } from "../../../constants/brandings";
import { readableColor } from "polished";

function TransactionDetails({
  successRatePercentage,
  selectedDropdownValue,
  Difference,
  prevFlag,
  loading,
  singleStartDate,
}) {
  return (
    <Paper
      style={{
        width: "100%",
        height: "114px",
        borderRadius: "20px",
        background: colorBrandObject?.mainKpiColor,
        padding: "20px",
      }}
    >
      {successRatePercentage && Difference && !loading ? (
        <>
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className="iconSpacing"
            >
              <Typography
                className="totalPaymentHeading labelSemiBold displayDirectionRow"
                style={{ color: readableColor(colorBrandObject?.mainKpiColor) }}
              >
                Success Rate
              </Typography>
              <Tooltip
                title={
                  "Successful transaction divided by the total transactions for a particular period."
                }
              >
                <IconButton
                  sx={{
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                  disableFocusRipple
                  disableTouchRipple
                >
                  <InfoOutlinedIcon
                    sx={{
                      color: readableColor(colorBrandObject?.mainKpiColor),
                      width: "14px",
                      height: "14px",
                      order: 1,
                      marginLeft: "2px",
                    }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </Typography>
          {successRatePercentage.length > 0 ? (
            successRatePercentage.map((item, idx) => (
              <Typography
                key={idx}
                className="headerH2Bold"
                style={{
                  color: readableColor(colorBrandObject?.mainKpiColor),
                  marginTop: "10px",
                  marginBottom: "4px",
                }}
              >
                {item["successRate"]} %
              </Typography>
            ))
          ) : (
            <Typography
              className="headerH2Bold"
              style={{
                color: readableColor(colorBrandObject?.mainKpiColor),
                marginTop: "10px",
                marginBottom: "4px",
              }}
            >
              0 %
            </Typography>
          )}
          {selectedDropdownValue !== "customDate" && (
            <Typography
              className="labelRegular"
              style={{
                color: readableColor(colorBrandObject?.mainKpiColor),
                marginTop: "4px",
              }}
            >
              {Difference - 0 !== 0
                ? Math.abs(Difference).toFixed(2) + "%"
                : ""}
              {prevFlag === false
                ? "No data to compare "
                : Difference - 0 > 0
                  ? " increase from "
                  : Difference - 0 === 0
                    ? " No change "
                    : " decrease from "}
              {Difference - 0 !== 0 &&
                selectedDropdownValue == "yesterday" &&
                "previous day"}
              {Difference - 0 !== 0 &&
                selectedDropdownValue == "today" &&
                "yesterday"}

              {Difference - 0 !== 0 &&
                selectedDropdownValue == "last3Months" &&
                "last 3 months"}
              {Difference - 0 !== 0 &&
                selectedDropdownValue == "last6Months" &&
                "last 6 months"}
              {Difference - 0 !== 0 &&
                selectedDropdownValue == "last12Months" &&
                "last 12 months"}
              {Difference - 0 !== 0 &&
                (selectedDropdownValue == "thisWeek" ||
                  selectedDropdownValue == "lastWeek") &&
                "last week"}
              {Difference - 0 !== 0 &&
                (selectedDropdownValue == "thisLastMonth" ||
                  selectedDropdownValue == "thisMonth") &&
                "last month"}
              {Difference - 0 !== 0 &&
                selectedDropdownValue == "thisYear" &&
                "last year"}
            </Typography>
          )}
        </>
      ) : (
        <div className="w-100">
          <Skeleton variant="text" width={150} height={25} />
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={120} height={20} />
        </div>
      )}
    </Paper>
  );
}

export default TransactionDetails;
